import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

const PALETTES = [
  { id: 'blossom', label: 'Blossom', colors: ['#FFD6E0', '#C8F4D6', '#E0D4FF'] },
  { id: 'fresh', label: 'Fresh', colors: ['#ACE5EE', '#E8F48C', '#FFFDD0'] },
  { id: 'sunset', label: 'Sunset', colors: ['#FFF5BA', '#4682B4', '#EFDECD'] },
];

export function ThemeProvider({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('willow-dark-mode') === 'true';
  });

  const [palette, setPalette] = useState(() => {
    return localStorage.getItem('willow-palette') || 'blossom';
  });

  useEffect(() => {
    localStorage.setItem('willow-dark-mode', darkMode);
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  useEffect(() => {
    localStorage.setItem('willow-palette', palette);
    document.documentElement.setAttribute('data-palette', palette);
  }, [palette]);

  const toggleDarkMode = () => setDarkMode(prev => !prev);

  const currentPalette = PALETTES.find(p => p.id === palette) || PALETTES[0];
  const currentColors = currentPalette.colors;

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode, palette, setPalette, PALETTES, currentColors }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
